export default {
    url: '/detail/:id',
    template: '<manage-permissions-sites-detail site="vm.site" users="vm.users" roles="vm.roles"></manage-permissions-sites-detail>',
    resolve: {
        site (SiteResource, $stateParams) {
            return SiteResource.get({ id: $stateParams.id, expand: 'users,parent' }).$promise;
        },
        roles (RoleResource) {
            return RoleResource.query({ pageSize: 0 }).$promise;
        }
    },
    controller (site, roles) {
        this.site = site;
        this.roles = [];
        roles.forEach((val) => {
            this.roles[val.id] = val;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/sites/detail/index.js